import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import SpogSpinner from 'components/ui/loading/SpogSpinner';

import 'style/components/ui/loading/loading-indicator.scss';

/** Component to render a loading spinner */
class LoadingIndicator extends Component {
    static propTypes = {
        text:      PropTypes.string, // The text to show
        height:    PropTypes.number, // The height of the panel if was necessary
        className: PropTypes.string // An optional className to pass the component
    };
    static defaultProps = {
        text:      'spinner.loading',
        className: ''
    };

    render() {
        const {
            height,
            text,
            className,
            intl:{formatMessage}
        } = this.props;

        return (
            <div
                className={`loading-indicator ${className} ${height ? 'height-setted' : ''}`}
                style={{height}}
            >
                <div className="loading-wrapper">
                    <div className="loading-container">
                        <p className="text-center text-muted">{formatMessage({id: text})}</p>
                        <SpogSpinner />
                    </div>
                </div>
            </div>
        );
    }
}


export default injectIntl(LoadingIndicator);



// WEBPACK FOOTER //
// ./src/components/ui/loading/LoadingIndicator.jsx